import {observer} from 'mobx-react';
import moment from 'moment';
import {Modal, ModalButtons} from 'shared/components/modals';
import {Button, DatePicker, FormLayout, LabelHelper, ObjectSelect2, QuickTip} from 'shared/components';
import {FormattedMessage} from 'react-intl';
import {t, withState} from 'shared/core';
import InterviewInviteModalState from 'main/containers/recruiting/state/InterviewInviteModalState';
import InterviewInvitePreviewModal from 'main/containers/recruiting/components/schedule_interview/InterviewInvitePreviewModal';
import useModal from 'shared/hooks/useModal';

const InterviewInviteModal = observer(({uiState, isOpen, onClose}) => {
  const {interviewInvite, scheduleOptions, editing, errors} = uiState;
  const previewModalOpen = useModal(uiState, 'PreviewModal');

  const selectedSchedule = interviewInvite.interviewSchedule;
  const canPreview = !!selectedSchedule && !!interviewInvite.startDate && !!interviewInvite.endDate;

  return (
    <Modal
      isOpen={isOpen}
      onHide={() => onClose()}
      size='sm'
      title={editing ? 'recruiting.hiring_funnel.Edit interview invite' : 'recruiting.hiring_funnel.Send interview schedule invite'}
    >
      <FormLayout>
        {interviewInvite.booked && <QuickTip
          trait='caution'
          paragraphs={[t('recruiting.hiring_funnel.Updating only affects potential rescheduling and does not change the already booked interview.')]}
        />}
        <ObjectSelect2
          label='recruiting.hiring_funnel.Interview schedule'
          placeholder='recruiting.hiring_funnel.Select an interview schedule'
          value={selectedSchedule}
          items={scheduleOptions}
          display='templateName'
          onChange={schedule => uiState.selectInterviewSchedule(schedule)}
          searchable
        />
        {selectedSchedule && <div>
          <LabelHelper label='recruiting.hiring_funnel.Allow booking from' translateLabel/>
          <div className='flex align-items-center gap-1'>
            <div className='flex-grow'>
              <DatePicker
                value={moment(interviewInvite.startDate)}
                onChange={date => interviewInvite.startDate = date}
                errorMessage={errors.startDate}
                options={{startDate: new Date()}}
              />
            </div>
            {'-'}
            <div className='flex-grow'>
              <DatePicker
                value={moment(interviewInvite.endDate)}
                onChange={date => interviewInvite.endDate = date}
                errorMessage={errors.endDate}
                options={{startDate: new Date()}}
              />
            </div>
          </div>
        </div>}
      </FormLayout>
      {canPreview &&
        <div className='mt2'>
          <Button trait='default' onClick={() => uiState.openPreviewModal()}>
            <FormattedMessage id='recruiting.hiring_funnel.Preview Invite'/>
          </Button>
        </div>}
      <ModalButtons
        onSave={() => uiState.saveInterviewInvite()}
        saveCaption={editing ? 'recruiting.hiring_funnel.Save' : 'recruiting.hiring_funnel.Send'}
        saveEnabled={!!selectedSchedule}
        onCancel={() => onClose()}
      />
      <InterviewInvitePreviewModal
        uiState={uiState}
        isOpen={previewModalOpen}
        onHide={() => uiState.closePreviewModal()}
      />
    </Modal>
  );
});

export default withState(InterviewInviteModal, InterviewInviteModalState);
